import { useAtom } from "jotai";
import { projectAtomList } from "../atoms";

// Custom hook to get the current project from the atom
const useCurrentProject = () => {
  const [currentProject] = useAtom(projectAtomList);
  return currentProject;
};

export default useCurrentProject;

